














































































































import { Component, Vue } from 'vue-property-decorator';

import { AuthUtile } from "../../auth/AuthUtile";
import { DbUtile, ResultDbCourseManagement } from "../../database/DbUtile";
import { DbUser, DbUserCourseManagement, DbUserCourseManagementDetail } from '../../database/DbUser';
import { DbCourseManagement, DbCourseManagementDetails } from "../../database/DbCourseManagement";
import { use } from 'vue/types/umd';

import BackButton from '@/components/BackButton.vue';
import Logout from '@/components/Logout.vue';
import Title from "@/components/Title.vue";
import Common from '@/common/Common';

@Component({
    components: {
        BackButton,
        Logout,
        Title
    },
    filters: {
        sec2min(t: number): string {
            const min = Math.floor(t / 60);
            const sec = Math.floor(t % 60);

            const mm = `00${min}`.slice(-2);
            const ss = `00${sec}`.slice(-2);
            return `${min}:${ss}`;
        }
    }
})
export default class StartOfCourse extends Vue {
    private authUtile: AuthUtile = new AuthUtile();
    private dbUtile: DbUtile = new DbUtile();

    // 管理者モードの確認
    isAdmin = false;

    // 現在日時
    now = new Date();

    userId: string | null = null;
    user: DbUser | null = null;

    // 講習ID
    courseManagementId = "";

    // 講習詳細 ID
    courseManagementDetailsId = "";

    // 講習
    courseManagement: DbCourseManagement | null = null;

    // 講習詳細 内容
    courseManagementDetail: DbCourseManagementDetails | null = null;

    // 視聴ボタン
    buttonNotWatchedHtml = "<a class='button is-danger'>未視聴</a>";

    // zoom 画像
    zoomImagePath = require("../../assets/res/zoom.png");

    // 再生中ステータス
    playerReady = false;

    // スライダー操作時再生中ステータス
    isChangeSliderInPlaying = false;

    // 動画進捗状況
    videoProgress = {
        currentSec: 0,
        maxSec: 0,
        duration: 0
    };

    // 再生完了判定子
    isDone = false;

    created() {
      console.log('created', this.user);
      this.authUtile.onAuthStateChanged()
        .then((user) => {
          // ログイン済み
          this._created();
        })
        .catch((e) => {
          console.error(e);
          alert('ログインしてください');
          const path = Common.getLoginPath(this.$route.path, this.$route.params.admin);
          this.$router.push(path);
        });
    }

    _created() {
        console.log('created');
        const currentUser = this.authUtile.currentUser();
        if (currentUser == null){
            alert('ログインしてください');
            const path = Common.getLoginPath(this.$route.path, this.$route.params.admin);
            this.$router.push(path);
            return;
        }
        // 講習詳細を取得する
        this.courseManagementId = this.$route.params['id'];
        this.courseManagementDetailsId = this.$route.params['did'];
        if ('admin' in this.$route.params) {
            this.isAdmin = ( this.$route.params['admin'] == 'true') ? true : false;
        }

        // 講習
        this.dbUtile.getCourseManagement(this.courseManagementId)
            .then((data) => {
                this.courseManagement = data;

                // 講習詳細を取得
                this.dbUtile.getCourseManagementDetail(this.courseManagementId, this.courseManagementDetailsId)
                    .then((data) => {
                        console.log(data);
                        this.courseManagementDetail = data;
                    });
            });

        if (this.isAdmin == false){
            // ログイン中ユーザー詳細情報を取得
            this.dbUtile.getCourseManagementUser(this.courseManagementId!, currentUser.uid)
                .then((data) => {
                    this.userId = data.id;
                    this.user = data.u;

                    // ユーザー 受講詳細 ステータスを取得
                    this.dbUtile.getUserCourseManagementDetail(this.userId!, this.courseManagementId!, this.courseManagementDetailsId!)
                        .then((ucmd) => {
                            this.isDone = false;
                            if (typeof ucmd === "undefined") {
                                return;
                            }
                            if (ucmd.status == DbUserCourseManagementDetail.STATUS.During){
                                // 視聴中
                                this.buttonNotWatchedHtml = "<a class='button is-primary'>視聴中</a>";
                            }
                            else if (ucmd.status == DbUserCourseManagementDetail.STATUS.Done){
                                // 完了
                                this.buttonNotWatchedHtml = "<a class='button is-danger'>完了</a>";
                                this.isDone = true;
                            }
                        });
                });
        }
    }

    // ライブ配信 の判定
    isLive() {
        if (this.courseManagementDetail == null){
            return false;
        }
        return (this.courseManagementDetail.classification == "オンデマンド")? false : true;
    }

    vimeoOnReady() {
        console.log('vimeoOnReady');
        const vimeoPlayer: any = this.$refs.vimeoPlayer;
        if (vimeoPlayer == null) {
            return;
        }
        // 動画の長さ
        vimeoPlayer.player.getDuration()
            .then((duration: number) => {
                console.log('duration', duration);
                this.videoProgress.duration = duration;

                // 旧キーがある場合はログイン中のユーザに紐づけ直して、旧キーは削除し、再生開始時間をセットしてリターン
                const oldKey = `video-current-time-${this.courseManagementId!}-${this.courseManagementDetailsId!}`;
                const oldData = localStorage.getItem(oldKey);
                if (oldData !== null) {
                    const json = JSON.parse(oldData);
                    const seconds = parseFloat(json.seconds);
                    this.videoProgress.currentSec = seconds;
                    this.videoProgress.maxSec = seconds;
                    this.saveVideoCurrentTime(this.videoProgress);
                    localStorage.removeItem(oldKey);
                    vimeoPlayer.player.setCurrentTime(this.videoProgress.currentSec);
                    return;
                }

                // 途中まで再生してた場合そこから再生
                const key = this.createKeyVideoCurrentTime();
                const data = localStorage.getItem(key);
                if (data !== null) {
                    const json = JSON.parse(data);
                    this.videoProgress.currentSec = parseFloat(json.currentSec);
                    this.videoProgress.maxSec = parseFloat(json.maxSec);
                }
                vimeoPlayer.player.setCurrentTime(this.videoProgress.currentSec);
            });
    }

    createKeyVideoCurrentTime(): string{
        const key = `video-current-time-${this.courseManagementId!}-${this.courseManagementDetailsId!}-${this.userId ?? 'admin'}`;
        return key;
    }

    saveVideoCurrentTime(videoProgress: object) {
        const key = this.createKeyVideoCurrentTime();
        localStorage.setItem(key, JSON.stringify(videoProgress));
    }

    // 再生 完了時
    vimeoOnEnded(event: any) {
        console.log('vimeoOnEnded', event);
        console.log(`-- seconds ${event.seconds} ${event.duration}`);
        if (event.seconds != event.duration) {
            return;
        }
        if (this.isAdmin == false) {
            const ucm = new DbUserCourseManagement();
            ucm.id = this.courseManagementId!;
            ucm.status = DbUserCourseManagement.STATUS.Done;
            this.dbUtile.addDbHistoryManagementDetails(this.userId!, this.user!, this.courseManagementId!, ucm, this.courseManagementDetailsId!, this.courseManagementDetail!)
                .then(() => {
                    // ユーザー 受講詳細 ステータスを更新
                    this.dbUtile.updateUserCourseManagementDetail(this.userId!, this.courseManagementId!, this.courseManagementDetailsId!, ucm.status)
                        .then((data) => {
                            console.log('updateUserCourseManagementDetail', data);
                        });

                    // ユーザーの他の完了確認 後に 概要 受講完了日を更新
                    this.doneHistoryManagement(ucm, false);
                });
        }
        // 完了判定子更新
        this.isDone = true;
        // 完了
        this.buttonNotWatchedHtml = "<a class='button is-danger'>完了</a>";
        // 再生時刻のリセット
        this.saveVideoCurrentTime({ ...this.videoProgress, 'currentSec': 0.0 });
        // 再生中ステータスを変更
        this.playerReady = false;
    }

    vimeoOnTimeupdate(event: any) {
        // console.log('vimeoOnTimeupdate', event);
        // 現在の再生時間
        this.videoProgress.currentSec = event.seconds;
        // 最大再生時間
        if (event.seconds > this.videoProgress.maxSec) {
            this.videoProgress.maxSec = event.seconds;
        }
        // 動画の長さ
        this.videoProgress.duration = event.duration;

        // 再生時間記録
        this.saveVideoCurrentTime(this.videoProgress);
    }

    // 再生開始
    playVimeoPlayer() {
        console.log("playVimeoPlayer");
        if (this.isAdmin == false) {
            // ログ登録
            const ucm = new DbUserCourseManagement();
            ucm.id = this.courseManagementId!;
            // ライブ配信は 完了, オンデマンドは During,
            ucm.status = (this.isLive()) ? DbUserCourseManagement.STATUS.Done : DbUserCourseManagement.STATUS.During;
            this.dbUtile.addDbHistoryManagementDetails(this.userId!, this.user!, this.courseManagementId!, ucm, this.courseManagementDetailsId!, this.courseManagementDetail!)
                .then(() => {
                    if (ucm.status == DbUserCourseManagement.STATUS.During){
                        // 概要 受講開始日を更新
                        this.dbUtile.addHistoryManagement(this.userId!, this.user!, this.courseManagementId!, ucm);
                    }
                    if (ucm.status == DbUserCourseManagement.STATUS.Done){
                        // ユーザーの他の完了確認 後に 概要 受講完了日を更新
                        this.doneHistoryManagement(ucm, this.isLive());
                    }

                    // ユーザー 受講詳細 ステータスを更新
                    this.dbUtile.updateUserCourseManagementDetail(this.userId!, this.courseManagementId!, this.courseManagementDetailsId!, ucm.status)
                        .then((data) => {
                            console.log('updateUserCourseManagementDetail', data);
                        });
                });
        }

        // 視聴ボタン変更
        this.buttonNotWatchedHtml = "<a class='button is-info'>視聴中</a>";
        if (this.isLive() == true) {
            console.log("meetingURL", this.courseManagementDetail!.meetingURL);
            // ZOOM 再生 外部リンク
            if (this.courseManagementDetail!.meetingURL == "") {
                return;
            }
            window.open(this.courseManagementDetail!.meetingURL, '_blank');
        }
        else {
            console.log("videoID", this.courseManagementDetail!.videoID);
            const vimeoPlayer: any = this.$refs.vimeoPlayer;
            if (vimeoPlayer == null) {
                return;
            }
            if (this.playerReady == false){
                vimeoPlayer.play();
                this.playerReady = true;
            }
            else {
                vimeoPlayer.pause();
                this.playerReady = false;
            }
        }
    }

    clickBack(){
        if (this.isAdmin == false) {
            this.$router.push({ name: 'AttendanceDetails', params: { id: this.courseManagementId } });
        }
        else {
            window.history.go(-1);
        }
        return false;
    }

    onTouchstartSlider(e: TouchEvent | MouseEvent): void {
        const elm = e.target as HTMLElement;
        if (elm === null || elm.className.indexOf('el-slider__button') === -1) return;

        this.isChangeSliderInPlaying = this.playerReady;
        if (this.playerReady) {
            const vimeoPlayer: any = this.$refs.vimeoPlayer;
            if (vimeoPlayer === null) return;

            vimeoPlayer.pause();
            this.playerReady = false;
        }
    }

    onTouchendSlider(e: TouchEvent | MouseEvent): void {
        const elm = e.target as HTMLElement;
        if (elm === null || elm.className.indexOf('el-slider__button') === -1) return;

        if (this.isChangeSliderInPlaying && !this.playerReady) {
            const vimeoPlayer: any = this.$refs.vimeoPlayer;
            if (vimeoPlayer === null) return;

            vimeoPlayer.play();
            this.playerReady = true;
        }
    }

    onChangeSlider(){
        const vimeoPlayer: any = this.$refs.vimeoPlayer;
        if (vimeoPlayer === null) return;

        // 視聴完了になっていない、かつ最大再生時間以上の場合は最大再生時間に戻す
        if (!this.isDone && this.videoProgress.currentSec > this.videoProgress.maxSec) {
            this.videoProgress.currentSec = this.videoProgress.maxSec;
        }
        // 再生位置移動
        vimeoPlayer.player.setCurrentTime(this.videoProgress.currentSec);
    }

    // 再生位置変更
    clickSetCurrentTime(sec: number) {
        const vimeoPlayer: any = this.$refs.vimeoPlayer;
        if (vimeoPlayer == null) {
            return;
        }
        console.log('vimeoPlayer', vimeoPlayer);
        vimeoPlayer.player.getCurrentTime()
            .then((seconds: number) => {
                let s = seconds + sec;
                if (s < 0) s = 0;
                vimeoPlayer.player.setCurrentTime(s)
                    .then((currentSeconds: number) => {
                        console.log("currentSeconds", currentSeconds);
                    })
                    .catch((error: any) => {
                        console.error(error);
                    });
            })
            .catch((error: any) => {
                console.error(error);
            });
    }

    // 再生速度変更
    clickPlaybackRate(rate: number) {
        const vimeoPlayer: any = this.$refs.vimeoPlayer;
        if (vimeoPlayer == null) {
            return;
        }
        console.log('vimeoPlayer', vimeoPlayer);
        vimeoPlayer.player.setPlaybackRate(rate)
            .then((playbackRate: number) => {
                console.log(playbackRate)
            }).catch((error: any) => {
                console.error(error);
            });
    }

    // ユーザーの他の完了確認 後に 概要 受講完了日を更新
    doneHistoryManagement(ucm: DbUserCourseManagement, isLive: boolean) {
        // 他の完了確認 後に 概要 受講完了日を更新
        setTimeout(() => {
            this.dbUtile.updateDoneHistoryManagement(this.userId!, this.courseManagementId!, isLive);
        }, 3000);
    }
}
